// extracted by mini-css-extract-plugin
export default {"paginationFooter":"Pagination_paginationFooter__+O--c","button":"Pagination_button__CJVj1","pageInfo":"Pagination_pageInfo__8Hb2j"};